import * as React from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import FooterStore from './store';
import LanguageSelect from '../language-select';
import Link from '@src/components/link';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import Config from './config';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const pageLocalesData = getPageLocalesData();
const footer = pageLocalesData.footer;
const lang = getLanguageByPath();

const Footer = ({ store }) => {
  store.use();
  return (
    <div className={styles.footerRoot}>
      <div className={styles.channelList}>
        <Link className={styles.youtube} onClick={() => store.shareLink('youtube_link')} />
        <Link className={styles.twitter} onClick={() => store.shareLink('twitter_link')} />
        <Link className={styles.discord} onClick={() => store.shareLink('discord_link')} />
        {/* <div className={styles.wxBox}>
          <Link className={cx(styles.wx)} onClick={() => store.selectWx()} />
          <div className={cx(styles.qrcode, store.wxActive && styles.showQr)}>
            <img src={toWebpImage(require('./images/wxcode.png'))} alt="" />
          </div>
        </div> */}

        {/* <Link className={styles.bilibili} href={store.bilibili_url} target={'_blank'} />

        <Link className={styles.qq} href={store.qq_url} target={'_blank'} />

        <Link className={styles.weibo} href={store.weibo_url} target={'_blank'} />

        <Link className={styles.link} onClick={() => store.copyLink()} /> */}
      </div>
      <div className={styles.content}>
        <div className={styles.languageSelectContainer}>
          <LanguageSelect store={store.languageSelectStore} className={styles.languageSelect} />
        </div>
        <div className={styles.logo} />
      </div>
      {/* <div className={styles.protocol}>
        <a className={styles.policy} href={PROTOCOL[getLanguageByPath()].privacy}>{getLocales('footer.privacy_policy')}</a>
        <div className={styles.split}></div>
        <a className={styles.service} href={PROTOCOL[getLanguageByPath()].service}>{getLocales('footer.terms_of_service')}</a>
      </div> */}
      <div className={styles.linkRow}>
        <Link className={styles.linkItem} href={Config[lang].cookie} target={'_blank'}>
          {footer.cookie_agreement}
        </Link>
        <div className={styles.split} />
        <div className={styles.linkItem} onClick={store.onCookieSettingsBtnClick}>
          {footer.cookie_setting}
        </div>
      </div>
      <div className={styles.linkRow}>
        <Link className={styles.linkItem} href={Config[lang].privacyPolicy} target={'_blank'}>
          {footer.privacy_agreement}
        </Link>
        <div className={styles.split} />
        <Link className={styles.linkItem} href={Config[lang].termsOfService} target={'_blank'}>
          {footer.right_of_useAgreement}
        </Link>
      </div>
      <div className={styles.copyRight}>© {store.currentYear} SEASUN GAMES PTE. LTD. All rights reserved.</div>
    </div>
  );
};

export default wrapStore(Footer, FooterStore);
